import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';

const StyledTableDataCell = styled(MuiBox, {
    shouldForwardProp: prop => !['isRowMenu', 'rtl', 'sticky', 'rowCellPadding'].includes(prop),
}) `
  ${({ theme, isRowMenu, width, rtl, sticky, rowCellPadding }) => `
    ${isRowMenu
    ? `
          position: absolute !important;
          transform: translateY(-50%);
          top: 50%;
          height: 90%;
          right: ${rtl ? 'auto' : '2px'} !important;
          left: ${rtl ? '2px' : 'auto'} !important;
        `
    : `
          z-index: 1;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          direction: ${rtl ? 'rtl' : 'ltr'};
          flex-wrap: wrap;
          text-overflow: ellipsis;
          color: ${theme.palette.N10.main};
          border: none;
          padding: ${width === 43
        ? theme.spacing(0, 3.5)
        : typeof rowCellPadding === 'number'
            ? `${rowCellPadding}px`
            : rowCellPadding || theme.spacing(0, 2.5)};
          ${sticky ? `background-color: ${theme.palette.N70.main};` : ''}
        `}
  `}
`;

export { StyledTableDataCell as default };
//# sourceMappingURL=StyledTableDataCell.js.map
